<template>
  <li class="mt-[4px] mb-[4px] w-full px-[10px] py-[6px] border border-[#CFCFCF] rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow text-base">
    <h2 class="font-jost-medium text-blue-dark text-base">{{ token.chainName }} Token</h2>
    <div class="flex items-center justify-between">    
      <!-- Middle: Token Details -->
      <div class="flex-1 flex items-center gap-[50px] mr-4 min-w-0">
        <!-- Hash - Truncated -->
        <div class="flex items-center min-w-0 flex-2">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Token:</span>
          <span class="text-[#374151] font-jost-regular text-base break-all" :title="token.token">
            {{ token.token }}
          </span>
        </div>

        <!-- Chain name -->
        <div class="flex items-center gap-2 text-base flex-2">
          <span class="text-[#6B7280]">Chain Name:</span>
          <RouterLink
            v-if="token.chainNumber !== undefined && token.chainNumber !== null"
            :to="{ name: 'chain', params: { chainNumber: token.chainNumber } }"
            class="text-[#374151] font-jost-regular"
            :title="token.chainName || 'N/A'"
          >
            {{ token.chainName || 'N/A' }}
          </RouterLink>
          <span v-else class="text-[#374151] font-jost-regular" :title="token.chainName || 'N/A'">
            {{ token.chainName || 'N/A' }}
          </span>
        </div>

        <div class="flex items-center min-w-0 flex-1">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Issuer:</span>
          <router-link v-if="token.issuer" :to="{name: 'account', params: { chainNumber: token.chainNumber, address: token.issuer }}"
            class="text-[#374151] font-jost-regular text-base">
               <span class="text-[#374151] font-jost-regular text-base" :title="token.issuer">
                {{ token.issuer && truncateAddress(token.issuer) || 'N/A' }}
              </span>
          </router-link>
        </div>
      </div>
      
      <!-- Right Side: Value + Time -->
      <div class="flex items-center gap-4 text-base">
        <div class="text-right">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Total supply:</span>
          <span class="text-[#374151] font-jost-regular text-base" :title="token.totalSupply">
            {{ token.totalSupply || 'N/A' }}
          </span> 
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { 
  formatDateTime, 
  truncateAddress
 } from '@/helpers/common';

export default {
  name: 'TokenCard',
  props: {
    token: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    formatDateTime(timestamp) {
      return formatDateTime(timestamp);
    },
    truncateAddress(address) {
      return truncateAddress(address);
    },
  }
}
</script>

<style scoped>
.transaction-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
</style>